<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Home':'होम'" routerLink="/">{{'Home'|translate}}</a></li>
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Circulars':'परिपत्र'" routerLinkActive="active-nemu" routerLink="/circular">{{'Circulars'|translate}}</a></li>
                <li class="breadcrumb-item"><a class="active-nemu screen-reader">{{"CircularDetails" |translate}}</a></li>
            </ol>
        </nav>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">

                <div class="col-lg-12">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title d-flex justify-content-between">
                                        <h2 class="screen-reader">{{"CircularDetails" |translate}}</h2>
                                    </div>
                                    <div class="description">
                                        <div class="circular-details">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <!-- press release details section - starts -->

                                                    <div class="circular-details-area">
                                                        <div
                                                            class="circular-details-title">
                                                            <div class="info screen-reader">
                                                                <h5 *ngIf="language=='English'">{{ htmlTag(circular_Details.title) }}</h5>
                                                                <h5 *ngIf="language=='Hindi'">{{ htmlTag(circular_Details.titleInHindi) }}</h5>
                                                            </div>
                                                        </div>
                                                        <div class="circular-details-desc content-details screen-reader font-adjust">
                                                            <p *ngIf="language=='English'" [innerHTML]="htmlTag(circular_Details.description)">                                                               
                                                            </p>

                                                            <p *ngIf="language=='Hindi'" [innerHTML]="htmlTag(circular_Details.descriptionInHindi)"></p>
                                                        </div>
                                                        <div
                                                            class="note-dates d-sm-flex align-items-center mt-1  font-adjust">
                                                            <div class="d-flex align-items-center flex-wrap">
                                                                <div class="opening-date screen-reader font-adjust" *ngIf="circular_Details.division != ''">
                                                                    <strong class="d-block txt-black">
                                                                        <span class="me-2"><i class="bi bi-building me-1"></i>
                                                                            {{ getDivisionName(circular_Details) }} 
                                                                        </span>
                                                                    </strong>
                                                                    <span class="labels text-muted">{{'Division'|translate}}</span>
                                                                </div>
                                                                <div class="opening-date screen-reader font-adjust">
                                                                    <strong class="d-block txt-black">
                                                                        <span class="me-2"> <i
                                                                                class="bi bi-calendar3 me-1"></i>
                                                                                {{ circular_Details.publishDate }}
                                                                            </span>
                                                                       
                                                                    </strong>
                                                                    <span class="labels text-muted">{{"DateOfIssue"|translate}}</span>
                                                                </div>

                                                                <div class="opening-date screen-reader font-adjust" *ngIf="checkFileExists(circular_Details)">
                                                                    <strong class="d-block">
                                                                        <a target="_blank" [href]="backend_url+'storage/app/uploads/'+circular_Details.uploadDocument" [attr.title]="language=='English'?'Download PDF':'डाउनलोड पीडीऍफ़'" class="text-green"><span class="me-2"> <i
                                                                                class="bi bi-download me-1"></i> {{'Download'| translate}}</span></a>
                                                                    </strong>
                                                                    <span class="labels text-muted">{{'FileSize'| translate}} ({{ circular_Details.uploadDocument_details.fileSize }} <span style="text-transform: uppercase;" *ngIf="checkFileType(circular_Details)!==false" [innerHtml]="checkFileType(circular_Details).file"></span>
                                                                    {{circular_Details.dtmCreatedOn | date:'MMM d, y'}})</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                               </div>
 
                                                    <!-- press release details section - ends -->


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>


<app-footer></app-footer>